import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonContent } from '@ionic/react'
import { classNames } from '@dt/fe-utils'
import { RequiredBadge } from 'components'
import { restaurantConfig, menuMobx, productCenter, storeMobx, cartMobx } from 'restaurant'
import { decorationMobx, recommendMobx } from '@mobxStore'
import { handleEleScrollTo, getPlatform } from '@utils'
import productStyleController from 'controllers/productStyleController'
import scrollController from 'controllers/scrollController'
import './index.scss'

// interface
interface IProps {
  useHeader?: boolean;
}

let classicCategoryListArr: HTMLElement[] = []
// 用于类tap的处理方式处理categoryBar
let startTouchX = 0
let startTouchY = 0
let moveTouchX = 0
let moveTouchY = 0
let startTime = 0
let st: any
const { isPhoneCase } = getPlatform()
const CategoryBar: FC<IProps> = ({ useHeader = false }) => {
  const [selectCategoryNo, setSelectCategoryNo] = useState('')
  const style = {
    '--background': 'var(--ion-color-primary, #312f2f)',
    // '--ion-background-fir': '#312f2f',
    // '--ion-background-sec': '#5A5858'
  }
  const initialState: any = {
    sidebarStyle: {
      '--padding-top': '0px',
      'height': 0,
      ...style
    }
  }
  const { info: selectedStore } = storeMobx
  const { categories } = recommendMobx
  const [sidebarStyle, seSidebarStyle] = useState(initialState.sidebarStyle)
  const [preventScroll, setPreventScroll] = useState(false)
  const { tabBarVisible, searchBarVisible, mealDecorates } = decorationMobx
  const diaplyMode = useHeader ? 'list' : restaurantConfig.displayMode
  // 处理选中分类
  const handleSelectCategory = function (e, no: string) {
    e.stopPropagation()
    setSelectCategoryNo(no)
    productStyleController.scollToCategory(no)
    // 处理滚动中的滚动
    setPreventScroll(true)
    st && clearTimeout(st)
    st = setTimeout(() => {
      setPreventScroll(false)
      handleSideBarActive()
    }, 1000)
    // setIsSidebarSelect(true)
  }
  useEffect(() => {
    if (categories.length) {
      // 计算侧边栏在浏览器中的高度
      // 经典模式在左侧，列表模式在顶部
      let sidebarTop = 0
      let sidebarHeight = 0
      sidebarHeight = window.innerHeight
      sidebarTop = searchBarVisible ? 56 : 0
      setTimeout(() => {
        const categoryBarUl = document.querySelector('.category-bar-ul') as any
        if (categoryBarUl && categoryBarUl.offsetHeight < sidebarHeight) {
          sidebarHeight = categoryBarUl.offsetHeight
        }
      })
      // 列表模式高度
      seSidebarStyle({
        'height': sidebarHeight || 48,
        ...style
      })
    }
  }, [categories, tabBarVisible, searchBarVisible])
  // 处理左右联动
  const handleSideBarActive = () => {
    if (preventScroll) {
      return
    }
    const clientHeight = document.documentElement.clientHeight
    if (!classicCategoryListArr.length) {
      classicCategoryListArr = [...document.querySelectorAll('.category-item')] as HTMLElement[]
    }
    // 在视口内的所有分类list
    const clientRects = classicCategoryListArr.filter(ele => {
      const { top } = ele.getBoundingClientRect()
      if (top > 0 && top - clientHeight + 50 < 0) {
        return true
      }
      return false
    })
    // 取在视口内的第一个分类
    const targetEle = clientRects[0]
    if (targetEle) {
      const id = targetEle.dataset.id || ''
      const no = id.split('category-')[1]
      // selectCategory(no)
      setSelectCategoryNo(no)
      // 将选择的分类滚动到视口内
      const { offsetLeft, offsetTop } = (document.querySelector(`#${id}`) as any) || {}
      handleEleScrollTo?.({
        selector: 'ion-content.category-bar-content',
        x: 0, // 180 能保证横向定位的元素前，能有2个元素左右
        y: offsetTop - 52 * 6, // 52 * 6 能保证基本定位的元素在中间
        duration: 0
      })
    }
  }
  // TODO 修改一种方式
  useEffect(() => {
    handleSideBarActive()
  }, [decorationMobx.menuScrollTop])

  // 切换门店时重置
  useEffect(() => {
    if (selectedStore.storeId) {
      // 数据上做了统一处理
      classicCategoryListArr = []
    }
  }, [selectedStore, cartMobx.info.eatType, productCenter.appointmentTime])
  return (
    <div
      className={classNames('menu-style-category-bar-wrapper', `${diaplyMode}-category-bar`)}
    >
      <IonContent
        className={classNames('category-bar-content')}
        style={sidebarStyle}
        scrollX={false}
        scrollY={categories.length > 4}
      >
        <ul className={classNames('category-bar-ul', `${mealDecorates.type || mealDecorates.categoryType || ''}`)}>
          {
            categories.map(({ no, name, pic, title, isRequired }, index) => {
              return (
                <li
                  key={no}
                  id={`category-${no}`}
                  // onClick={(e) => {
                  //   handleSelectCategory(e, no)
                  // }}
                  onTouchStart={(e) => {
                    const touch = e.targetTouches?.[0]
                    moveTouchX = startTouchX = touch.clientX
                    moveTouchY = startTouchY = touch.clientY
                    startTime = Date.now()
                  }}
                  onTouchMove={(e) => {
                    const touch = e.targetTouches?.[0]
                    moveTouchX = touch.clientX
                    moveTouchY = touch.clientY
                  }}
                  onTouchEnd={(e) => {
                    e.stopPropagation()
                    if (Date.now() - startTime < 500) {
                      if (Math.abs(moveTouchX - startTouchX) <= 11 && Math.abs(moveTouchY - startTouchY) <= 11) {
                        if (scrollController.isScrolling) {
                          setTimeout(() => {
                            handleSelectCategory(e, no)
                          }, 200)
                        } else {
                          handleSelectCategory(e, no)
                        }
                      }
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (isPhoneCase) {
                      if (scrollController.isScrolling) {
                        setTimeout(() => {
                          handleSelectCategory(e, no)
                        }, 200)
                      } else {
                        handleSelectCategory(e, no)
                      }
                    }
                  }}
                  className={classNames({
                    active: no === selectCategoryNo || (index === 0 && !selectCategoryNo)
                  })}
                >
                  {isRequired && <RequiredBadge className='required-category-badge' />}
                  {pic ? <img src={pic} /> : null}
                  <div style={{ fontSize: `${mealDecorates?.fontSetting?.category?.fontSize || 16}px`, fontWeight: mealDecorates?.fontSetting?.category?.fontWeight ? 700 : 500 }}>{name}</div>
                  <span>{title}</span>
                </li>
              )
            })
          }
        </ul>
      </IonContent>
    </div>
  )
}

export default observer(CategoryBar)
